import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Config from '@skin_config';
import NumericInput from '@common/components/numericInput';
import { GetCurrencyConfig } from '@common/helpers/selectors';
import { useTranslation } from '@common/hooks/translation';

import { roundAmount } from '@betslip/src/rules/calculation/helpers';

import { useBalance } from '../../hooks/balance';

const suggestedAmountPercents = [10, 25, 50, 75, 100];

const CashoutPartialAmount = ({ errorMessage, amount, onChange }) => {
  const balance = useBalance();
  const t = useTranslation();

  const currencyConfig = useSelector((state) => (
    GetCurrencyConfig(state, Config.currencySymbolRounding)
  ));

  const suggestedAmounts = useMemo(() => {
    const roundCoefficient = Math.max(Math.round(balance).toString().length - 1, 0);
    const roundedBalance = (
      Math.trunc((balance / 10 ** roundCoefficient)) * (10 ** roundCoefficient)
    );

    return (
      [
        ...new Set(
          suggestedAmountPercents.map((percent) => (
            Math.round(roundAmount((roundedBalance * percent) / 100, currencyConfig, false))
          )),
        ),
      ]
    )
  }, [balance, currencyConfig]);

  return (
    <div className="cashout-partial-amount-wrapper">
      <NumericInput
        value={amount}
        onChange={onChange}
        placeholder="Cash out amount"
        maxDecimalCount={currencyConfig?.rounding || 2}
        className={errorMessage ? 'cashout-amount-input-error' : ''}
      />

      {errorMessage && <p className="cashout-amount-error-message">{t(errorMessage)}</p>}

      {balance >= 10 && (
        <div className="partial-cashout-suggestions">
          <h3>{t('Suggested for you')}</h3>
          <div>
            {suggestedAmounts.map((suggestion) => (
              <button key={suggestion} type="button" onClick={() => onChange?.(suggestion)}>
                {suggestion}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

CashoutPartialAmount.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  errorMessage: PropTypes.string,
};

export default CashoutPartialAmount;
